"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPlainObject = isPlainObject;
/* !
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}
function isPlainObject(obj) {
  if (!isObject(obj)) {
    return false;
  }

  // If has modified constructor
  const {
    constructor
  } = obj;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- we want to check this
  if (constructor === undefined) {
    return true;
  }

  // If has modified prototype
  const prototype = constructor.prototype;
  if (!isObject(prototype)) {
    return false;
  }

  // If constructor does not have an Object-specific method
  // eslint-disable-next-line no-prototype-builtins -- we have to access isPrototypeOf with hasOwnProperty
  if (!prototype.hasOwnProperty('isPrototypeOf')) {
    return false;
  }

  // Most likely a plain Object
  return true;
}
//# sourceMappingURL=isPlainObject.js.map